import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/da1hf19st185ek8asqs0";

export default function Subscribe() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    // 蜜罐检测：若被填值则直接走成功反馈，避免暴露拦截信号
    const honeypot = String(formData.get("website_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，感谢你的关注！");
      form.reset();
      setEmail("");
      return;
    }

    if (!email.trim()) {
      setStatus("error");
      setMessage("请填写有效的邮箱地址。");
      return;
    }

    setStatus("loading");
    setMessage("");
    formData.delete("website_alt");

    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const serverCode = parsed?.code;
      const isSpam = String(responseText).includes("spam") || String(serverMsg).includes("spam");

      if (res.ok && serverCode === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，最新韩漫资讯将第一时间送达你的邮箱。");
        form.reset();
        setEmail("");
      } else {
        setStatus("error");
        setMessage(isSpam ? "提交过于频繁，请稍后再试。" : serverMsg || "订阅失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  }

  return (
    <section className="mx-auto px-4 md:px-8 pb-14 md:pb-20">
      <div className="relative rounded-lg overflow-hidden bg-primary-600">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-800 via-primary-600 to-accent-600 opacity-90" />
        <div className="relative w-full px-5 md:px-12 py-10 md:py-14 flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
          <div className="max-w-xl text-center lg:text-left">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-950">
              订阅韩漫馆，追更资讯不迷路
            </h3>
            <p className="mt-2 text-sm md:text-base text-background-950/80">
              订阅后即可第一时间获取每日更新提醒、热门韩漫推荐与编辑精选合集。
            </p>
          </div>

          <form
            id="subscribe-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="w-full max-w-md flex flex-col sm:flex-row gap-3"
          >
            <div className="relative flex-1">
              <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-background-950/70" />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入你的邮箱"
                required
                className="w-full rounded-md bg-background-50/95 pl-11 pr-4 py-3 text-sm text-background-950 placeholder-foreground-600 outline-none focus:ring-2 focus:ring-background-200"
              />
            </div>
            {/* 反垃圾蜜罐字段 */}
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-950 hover:bg-background-900 text-primary-400 px-6 py-3 text-sm font-semibold transition-colors cursor-pointer disabled:opacity-60"
            >
              {status === "loading" ? (
                <i className="ri-loader-4-line animate-spin text-lg" />
              ) : (
                <>
                  <i className="ri-send-plane-fill" />
                  立即订阅
                </>
              )}
            </button>
          </form>
        </div>
        {status !== "idle" && (
          <p
            className={`relative px-5 md:px-12 pb-4 text-sm ${
              status === "success" ? "text-background-950" : "text-accent-950"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
}